import React from 'react';
import { useSendbirdConnection } from '../hooks';
import { ConnectionStatus } from './ConnectionStatus';
import { ChatConnectingState } from './ChatConnectingState';
import { ChatConnectionFallback } from './ChatConnectionFallback';
import { IWithSendbirdConnectionProps } from '../types';

export const withSendbirdConnection = <P extends object>(
    WrappedComponent: React.ComponentType<P>,
    options: IWithSendbirdConnectionProps = {}
) => {
    const {
        useDetailedConnectionStatus = true,
    } = options;
    return (props: P) => {
        const connectionState = useSendbirdConnection();
        const { isConnecting, isConnected, connectionError, refreshToken } = connectionState;

        if (isConnecting) {
            return <ChatConnectingState />;
        }

        if (!isConnected || connectionError) {
            if (useDetailedConnectionStatus) {
                return (
                    <ConnectionStatus
                        isConnecting={isConnecting}
                        isConnected={isConnected}
                        connectionError={connectionError}
                        onReconnect={refreshToken}
                    />
                );
            } else {
                return <ChatConnectionFallback />;
            }
        }

        return (
            <WrappedComponent
                {...props}
                sendbirdConnection={connectionState}
            />
        );
    };
};
